import { ContactSupport, CookieOutlined } from '@mui/icons-material';
import {
  AUTH_CONTACT_US_URL,
  AUTH_ENABLE_CONTACT_US_LINK,
  AUTH_ENABLE_COOKIE_PREFERENCES_LINK,
  PRIVACY_POLICY_LABEL,
  PRIVACY_POLICY_URL,
  TERMS_OF_SERVICE_LABEL,
  TERMS_OF_SERVICE_URL,
} from 'common/constants/auth';
import { useCookieConsent } from 'common/providers/CookieConsentProvider';
import { TextLink } from 'components/ui';
import {
  AUTH_FOOTER_CONTACT_US_LABEL,
  AUTH_FOOTER_MANAGE_COOKIE_PREFERENCES_LABEL,
} from './AuthFooterLinks.constants';
import { AuthFooterLinksGroup, AuthFooterLinksRoot } from './AuthFooterLinks.styles';

const AuthFooterLinks = () => {
  const { showPreferences } = useCookieConsent();

  return (
    <AuthFooterLinksRoot>
      {AUTH_ENABLE_CONTACT_US_LINK ? (
        <AuthFooterLinksGroup>
          <TextLink
            href={AUTH_CONTACT_US_URL}
            rel="noopener noreferrer"
            target="_blank"
            variant="body2"
            visualVariant="footer"
          >
            <ContactSupport />
            {AUTH_FOOTER_CONTACT_US_LABEL}
          </TextLink>
        </AuthFooterLinksGroup>
      ) : null}
      <AuthFooterLinksGroup>
        {AUTH_ENABLE_COOKIE_PREFERENCES_LINK ? (
          <TextLink
            component="button"
            onClick={showPreferences}
            type="button"
            variant="body2"
            visualVariant="footer"
          >
            <CookieOutlined />
            {AUTH_FOOTER_MANAGE_COOKIE_PREFERENCES_LABEL}
          </TextLink>
        ) : null}
        <TextLink
          href={TERMS_OF_SERVICE_URL}
          rel="noopener noreferrer"
          target="_blank"
          variant="body2"
          visualVariant="footer"
        >
          {TERMS_OF_SERVICE_LABEL}
        </TextLink>
        <TextLink
          href={PRIVACY_POLICY_URL}
          rel="noopener noreferrer"
          target="_blank"
          variant="body2"
          visualVariant="footer"
        >
          {PRIVACY_POLICY_LABEL}
        </TextLink>
      </AuthFooterLinksGroup>
    </AuthFooterLinksRoot>
  );
};

export default AuthFooterLinks;
